export const changeDateFormat = ({ date, term = "." }) => {
    let changedDate = date.toLocaleDateString();
    changedDate = changedDate.split("/").join(term);
    return changedDate;
}

export const toTime = (dateStr) => {
    return new Date(dateStr).getTime();
}